import React, { useState } from "react";
import { Link } from "react-router-dom";

const DAILY_CARE_LOG_PATH = "/daily-care-log";

const formatIncidentTimestampForDisplay = (timestamp) => {
  if (timestamp && timestamp.toDate) {
    return timestamp.toDate().toLocaleString();
  }
  return "N/A";
};

const RecentIncidents = ({ incidents }) => {
  const [showAll, setShowAll] = useState(false);

  if (!incidents || incidents.length === 0) {
    return (
      <div className="rounded-2xl bg-slate-50 p-4 text-center">
        <p className="text-sm text-slate-500">
          No recent incidents to display.
        </p>
        <p className="mt-1 text-xs text-slate-400">
          Showing incidents reported in the past 14 days.
        </p>
        <Link
          to={DAILY_CARE_LOG_PATH}
          className="mt-3 inline-block text-sm font-semibold text-blue-600 hover:text-blue-700"
        >
          Add Daily Care Log →
        </Link>
      </div>
    );
  }

  const visibleIncidents = showAll ? incidents : incidents.slice(0, 2);
  const hasMore = incidents.length > 2;

  return (
    <div>
      <p className="mb-3 text-xs text-slate-500">
        Showing incidents reported in the past 14 days.
      </p>
      <ul className="space-y-3">
        {visibleIncidents.map((incident) => (
          <li key={incident.id}>
            <Link
              to={DAILY_CARE_LOG_PATH}
              className="block rounded-2xl border border-orange-100 bg-orange-50/70 p-4 transition hover:bg-white hover:shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
            >
              <p className="font-semibold text-slate-950">
                {incident.description}
              </p>
              <p className="mt-1 text-sm text-slate-500">
                <span className="font-medium text-orange-700">
                  {incident.type}
                </span>{" "}
                - Reported on{" "}
                {formatIncidentTimestampForDisplay(incident.dateTime)}
              </p>
            </Link>
          </li>
        ))}
      </ul>
      <div className="mt-4 flex items-center justify-between gap-3">
        {hasMore ? (
          <button
            onClick={() => setShowAll(!showAll)}
            className="text-sm font-semibold text-blue-600 hover:text-blue-700"
          >
            {showAll ? "Show Less" : `View All (${incidents.length}) →`}
          </button>
        ) : (
          <div /> /* Spacer */
        )}
        <Link
          to={DAILY_CARE_LOG_PATH}
          className="text-sm font-semibold text-blue-600 hover:text-blue-700"
        >
          Open Daily Care Log →
        </Link>
      </div>
    </div>
  );
};

export default RecentIncidents;
